import { FLAG_CATEGORIES, FLAG_DEFAULTS, type FlagCategory, type FlagKey } from './flags.generated'

export type FlagMap = Partial<Record<FlagKey, boolean>> & Record<string, boolean>

/** Registry default for a key. Unknown keys are treated as false (safe miss). */
export function flagValue(flags: FlagMap | undefined, key: FlagKey): boolean {
  if (flags && Object.prototype.hasOwnProperty.call(flags, key)) {
    return Boolean(flags[key])
  }
  return Boolean((FLAG_DEFAULTS as Record<string, boolean | undefined>)[key as string])
}

export function isOpsFlag(key: string): boolean {
  return (FLAG_CATEGORIES as Record<string, FlagCategory | undefined>)[key] === 'ops'
}

/**
 * Non-ops values evaluated at dispatch. Kill switches are never pinned —
 * workers re-read them live.
 */
export function pinNonOps(flags: FlagMap | undefined): Record<string, boolean> {
  const out: Record<string, boolean> = {}
  for (const key of Object.keys(FLAG_DEFAULTS) as FlagKey[]) {
    if (isOpsFlag(key)) continue
    out[key] = flagValue(flags, key)
  }
  return out
}

export function snapshotsEqual(a: FlagMap | undefined, b: FlagMap | undefined): boolean {
  const keys = new Set([...Object.keys(a ?? {}), ...Object.keys(b ?? {})])
  for (const key of keys) {
    if (Boolean(a?.[key]) !== Boolean(b?.[key])) return false
  }
  return true
}
